__turbopack_context__.v({
  "amount": "responsible-gaming-module-sass-module__YTQq8G__amount",
  "btnContainer": "responsible-gaming-module-sass-module__YTQq8G__btnContainer",
  "compact": "responsible-gaming-module-sass-module__YTQq8G__compact" + " " + __turbopack_context__.i(77712)["blockContent"],
  "compactHeader": "responsible-gaming-module-sass-module__YTQq8G__compactHeader" + " " + __turbopack_context__.i(404552)["compactHeader"],
  "confirmModal": "responsible-gaming-module-sass-module__YTQq8G__confirmModal",
  "confirmModalBtns": "responsible-gaming-module-sass-module__YTQq8G__confirmModalBtns",
  "confirmModalContent": "responsible-gaming-module-sass-module__YTQq8G__confirmModalContent",
  "confirmModalHeader": "responsible-gaming-module-sass-module__YTQq8G__confirmModalHeader",
  "default": "responsible-gaming-module-sass-module__YTQq8G__default",
  "form": "responsible-gaming-module-sass-module__YTQq8G__form",
  "responsibleGaming": "responsible-gaming-module-sass-module__YTQq8G__responsibleGaming",
});
